export default {
  init($) {},
  finalize($) {
    // $('.posts-greed .wrap-categories a, .posts-greed .all-categories').on('click', event => {
    //   const microsite = $(event.currentTarget).data('microsite');
    //   const $posts = $('.posts-greed .post-item');
    //
    //   if(microsite) {
    //     $posts.each((i, el) => {
    //       const $el = $(el);
    //       if(!$el.hasClass(`item-${microsite}`)) {
    //         $el.hide();
    //       } else {
    //         $el.fadeIn(750);
    //       }
    //     });
    //   } else {
    //     $posts.each((i, el) => {
    //       const $el = $(el);
    //       $el.fadeIn(750);
    //     });
    //   }
    // });
  }
}
